export enum PilotCustomSupportedProductCodes {
  SmartCal = 11,
  G3 = 12,
  PMD2 = 13,
  T4 = 37
}

export enum PilotCustomSupportedSubTypes {
  App = 0,
  Main = 0
}

export enum PilotCustomSupportedVariants {
  USA = 0
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/interfaces/PilotCustomReleaseProducts.ts